import { render, staticRenderFns } from "./TenantEditWorkflowStatusDialog.vue?vue&type=template&id=47e841b6&scoped=true&"
import script from "./TenantEditWorkflowStatusDialog.vue?vue&type=script&lang=js&"
export * from "./TenantEditWorkflowStatusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e841b6",
  null
  
)

export default component.exports